import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Input, Flex, Select } from 'antd';
import { useGetCountries } from 'api/countries/use-get-countries';
import { transformCountriesForForm } from 'shared/utils/countries';
import type { TFieldInputValue } from 'components/trips/trip-create-task-modal/types';
import styles from './shared-address-fields.module.scss';
import type { ISharedAddressFieldsProps } from './types';

export const SharedAddressFields = (props: ISharedAddressFieldsProps) => {
  const { value, disabled = false, onChange } = props;
  const { t } = useTranslation('common');
  const { data: countries } = useGetCountries();
  const transformedCountries = useMemo(() => transformCountriesForForm(countries), [countries]);

  const handleFieldChange = (field: string, fieldValue: TFieldInputValue) => {
    if (onChange) {
      onChange({ ...value, [field]: fieldValue });
    }
  };

  return (
    <Flex vertical>
      <Form.Item label={t('name')} className={styles.input}>
        <Input
          placeholder={disabled ? undefined : t('name')}
          value={value.name}
          disabled={disabled}
          onChange={(e) => handleFieldChange('name', e.target.value)}
        />
      </Form.Item>

      <Form.Item label={t('country')} className={styles.input}>
        <Select
          optionFilterProp='label'
          placeholder={disabled ? undefined : t('country')}
          value={value.countryId}
          options={transformedCountries}
          showSearch={!disabled}
          disabled={disabled}
          onChange={(option) => handleFieldChange('countryId', option)}
        />
      </Form.Item>

      <Form.Item label={t('post_code')} className={styles.input}>
        <Input
          placeholder={disabled ? undefined : t('post_code')}
          value={value.postCode}
          disabled={disabled}
          onChange={(e) => handleFieldChange('postCode', e.target.value)}
        />
      </Form.Item>

      <Form.Item label={t('city')} className={styles.input}>
        <Input
          placeholder={disabled ? undefined : t('city')}
          value={value.city}
          disabled={disabled}
          onChange={(e) => handleFieldChange('city', e.target.value)}
        />
      </Form.Item>

      <Form.Item label={t('address')} className={styles.input}>
        <Input
          placeholder={disabled ? undefined : t('address')}
          value={value.address}
          disabled={disabled}
          onChange={(e) => handleFieldChange('address', e.target.value)}
        />
      </Form.Item>
    </Flex>
  );
};
